import React from 'react';
import { Button, Flex, Stack } from '@grubhubprod/gh-cookbook-react';
import { CreditCardFormIframe } from 'src/components/CreditCardFormIframe/CreditCardFormIframe';
import { useCreditCardIframe } from 'src/components/CreditCardFormIframe/useCreditCardIframe';

export interface IAccountPaymentForm {
  isPhone?: boolean;
  corpId: string;
  cardId?: string;
  onClose: () => void;
  onSuccess: () => void;
  onError: () => void;
}

export function AccountPaymentForm({
  corpId,
  onClose,
  onSuccess,
  isPhone,
  onError,
  cardId,
}: IAccountPaymentForm): JSX.Element {
  const {
    onIframeSubmit,
    iframeContainerId,
    cardIsValid,
    isSubmitting,
    isLoadingComponent,
  } = useCreditCardIframe({
    corpId,
    cardId,
    onSuccess,
    onError,
    idSuffix: 'ss-account-payment',
  });

  return (
    <form>
      <CreditCardFormIframe
        id={iframeContainerId}
        isLoadingComponent={isLoadingComponent}
      />
      <Flex
        flexWrap={isPhone ? 'wrap' : 'nowrap'}
        flexDirection={isPhone ? 'column-reverse' : 'row'}
      >
        <Stack
          width={isPhone ? '100%' : 'initial'}
          x={isPhone ? 'none' : 'x-sm'}
        >
          <Button
            block
            type="button"
            variant="secondary"
            buttonSize="medium"
            onClick={onClose}
          >
            Cancel
          </Button>
        </Stack>
        <Stack
          minWidth="140px"
          y={isPhone ? 'sm' : 'none'}
          width={isPhone ? '100%' : 'initial'}
        >
          <Button
            block
            variant="primary"
            buttonSize="medium"
            onClick={(evt): void => {
              evt.preventDefault();
              onIframeSubmit();
            }}
            disabled={!cardIsValid || isSubmitting}
            isLoading={isSubmitting}
          >
            Save credit card
          </Button>
        </Stack>
      </Flex>
    </form>
  );
}
